import React from "react";
import LoadingButton from "../../dumb/LoadingButton";
import useModal from "../../../hook/useModal";
import useStatusThunk from "../../../hook/useStatusThunk";
import DisplayError from "../../dumb/DisplayError";
import { deleteAnalysis } from "../../../redux/ducks/analysis";

const DeleteAnalysis = props => {
    const [show, hide, renderModal] = useModal();

    const [d_deleteAnalysis, status, error, event] = useStatusThunk(deleteAnalysis);

    const deleteA = () => {
        if (props.analysisIDs.length > 0) d_deleteAnalysis({ IDs: props.analysisIDs, projectID: props.projectID });
    }

    event.onSuccess = () => hide();

    return (
        <React.Fragment>
            <button className={"button button--danger " + props.className} onClick={show}>Delete</button>
            {renderModal(
                <div>
                    <div className="group">
                        <DisplayError error={error} />
                    </div>

                    <LoadingButton loading={status == "pending"} className={"button--danger"} onClick={() => deleteA()}>Delete</LoadingButton>
                </div>
            )}
        </React.Fragment>
    )
}

export default DeleteAnalysis;